import { render, staticRenderFns } from "./MobileWelfareLottery.vue?vue&type=template&id=00290ba9&"
import script from "./MobileWelfareLottery.vue?vue&type=script&lang=js&"
export * from "./MobileWelfareLottery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports